export const AIR_ENEMY_KINDS = ['flying', 'acornBat', 'swooperBat', 'leafMoth', 'leafWasp'];

export const STATIC_OBSTACLE_KINDS = ['thistle', 'bramble', 'crystalSpike', 'fencePost'];

export const PATROL_ENEMY_KINDS = [
  'ground',
  'enemy',
  'chestnut',
  'mushroomHopper',
  'rollingChestnut',
  'turnipHopper',
  'fireSalamander',
  'pineconeCharger',
  'crystalSnail',
];

export const ENEMY_SCORES = {
  air: 180,
  fireSalamander: 220,
  pineconeCharger: 190,
  crystalSnail: 210,
  rollingChestnut: 170,
  turnipHopper: 165,
  default: 140,
};

export const ENEMY_BEHAVIOR = {
  rollingChestnut: {
    width: 52,
    height: 40,
    yOffset: 43,
    patrolSpeed: [24, 38],
    difficultySpeed: 20,
    dashBoost: 96,
    dashDuration: 0.34,
    dashCooldown: [1.1, 2.0],
  },
  swooperBat: {
    width: 72,
    height: 58,
    baseYOffset: [118, 164],
    diveAmplitude: [34, 58],
    vx: [34, 54],
    difficultySpeed: 24,
    waveSpeed: 2.8,
  },
  leafMoth: {
    width: 72,
    height: 58,
    baseYOffset: [120, 176],
    verticalAmplitude: [52, 86],
    vx: [22, 38],
    difficultySpeed: 16,
    waveSpeed: [2.2, 3.2],
  },
  leafWasp: {
    width: 68,
    height: 52,
    baseYOffset: [126, 184],
    verticalAmplitude: [28, 46],
    vx: [46, 68],
    difficultySpeed: 28,
    waveSpeed: [4.0, 5.2],
  },
  turnipHopper: {
    width: 54,
    height: 43,
    yOffset: 49,
    patrolSpeed: [16, 27],
    difficultySpeed: 15,
    hopHeight: [28, 48],
    hopSpeed: [3.0, 4.3],
    airSpeedBoost: 1.55,
  },
  fireSalamander: {
    width: 56,
    height: 46,
    yOffset: 50,
    patrolSpeed: [10, 19],
    difficultySpeed: 9,
    fireCooldown: [2.2, 3.6],
    projectileSpeed: [118, 160],
  },
  pineconeCharger: {
    width: 58,
    height: 42,
    yOffset: 45,
    patrolSpeed: [20, 32],
    difficultySpeed: 18,
    dashBoost: 125,
    dashDuration: 0.42,
    dashCooldown: [1.2, 2.1],
    hopHeight: 10,
  },
  crystalSnail: {
    width: 58,
    height: 40,
    yOffset: 45,
    patrolSpeed: [8, 15],
    difficultySpeed: 7,
  },
};

export const ENEMY_RENDERING = {
  rollingChestnut: {
    sprite: 'chestnutEnemy',
    frameRate: 13,
    spinSpeed: 5.6,
    xOffset: -8,
    yOffset: -17,
    widthPadding: 20,
    heightPadding: 30,
  },
  swooperBat: {
    sprite: 'acornBat',
    frameRate: 14,
    xOffset: -15,
    yOffset: -18,
    widthPadding: 30,
    heightPadding: 36,
  },
  leafMoth: {
    sprite: 'leafMoth',
    frameRate: 12,
    xOffset: -14,
    yOffset: -16,
    widthPadding: 28,
    heightPadding: 32,
  },
  leafWasp: {
    sprite: 'leafWasp',
    frameRate: 15,
    xOffset: -14,
    yOffset: -15,
    widthPadding: 28,
    heightPadding: 30,
  },
  turnipHopper: {
    sprite: 'turnipHopper',
    frameRate: 9,
    xOffset: -10,
    yOffset: -20,
    widthPadding: 22,
    heightPadding: 32,
  },
  fireSalamander: {
    sprite: 'fireSalamander',
    frameRate: 8,
    xOffset: -11,
    yOffset: -23,
    widthPadding: 24,
    heightPadding: 34,
  },
  pineconeCharger: {
    sprite: 'pineconeCharger',
    frameRate: 13,
    xOffset: -13,
    yOffset: -18,
    widthPadding: 28,
    heightPadding: 30,
  },
  crystalSnail: {
    sprite: 'crystalSnail',
    frameRate: 6,
    xOffset: -12,
    yOffset: -20,
    widthPadding: 26,
    heightPadding: 32,
  },
};
